import { MenuItem } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import * as React from "react";
import { getMingleCountries } from "../utils/api.interfaces";

interface CountryFilterProps {
  initSelectedCountry?: string | null;
  onCountryChange: (event: SelectChangeEvent<string | null>) => void;
}
const CountryFilter: React.FC<CountryFilterProps> = ({
  onCountryChange,
  initSelectedCountry,
}) => {
  return (
    <div
      style={{
        width: "260px",
        minWidth: "260px",
      }}
    >
      <Select
        labelId="countryCode"
        id="countryCode"
        name="countryCode"
        value={initSelectedCountry}
        label="countryCode"
        onChange={(e) => onCountryChange(e)}
      >
        {getMingleCountries().map((country: any) => (
          <MenuItem key={country.code} value={country.code}>
            {country.name} ({country.code})
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default CountryFilter;
